import React from 'react';
import { useNavigate } from 'react-router-dom';
import './WizardCompletion.css';

export default function WizardCompletion({ isArabic, language, translations }) {
  const navigate = useNavigate();
  const t = translations || {};

  return (
    <div className="wizard-completion-container">
      <div className="wizard-completion-card">
        <div className="completion-icon">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth="2">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
            <polyline points="22 4 12 14.01 9 11.01" />
          </svg>
        </div>
        <h2 className="completion-title">{t.submissionReceived || 'Submission Received!'}</h2>
        <p className="completion-message">
          {t.thankYouMessage || 'Thank you for completing your teacher profile submission.'}
        </p>
        <p className="completion-submessage">
          {t.emailNotification || 'The Taealam team will see your request in 24 hours and will answer you in the same time.'}
        </p>
        <button 
          className="btn btn-primary" 
          onClick={() => navigate('/dashboard/teacher/profile')}
          style={{ marginTop: '24px' }}
        >
          {t.goToDashboard || 'Go to Dashboard'}
        </button>
      </div>
    </div>
  );
}